<template>
    <div class="acute-toxicity">
        <!-- Tabla -->
        <b-row class="mt-0">
            <b-col class="table-responsive">
                <table class="table table-hover">
                    <thead>
                    <tr>
                        <th rowspan="2"
                            class="align-content-center"
                        >
                            COMPONENTE
                        </th>
                        <th rowspan="2"
                            class="text-center align-content-center"
                        >
                            PORCENTAJE
                        </th>
                        <th colspan="3"
                            class="text-center"
                        >
                            ORAL (DL50)
                        </th>
                        <th colspan="3"
                            class="text-center"
                        >
                            CUTÁNEA (DL50)
                        </th>
                        <th colspan="3"
                            class="text-center"
                        >
                            INHALACIÓN (CL50)
                        </th>
                        <th rowspan="2"
                            style="width: 50px;"
                            v-if="!only_view"
                        >
                        </th>
                    </tr>
                    <tr>
                        <th class="th-check"></th>
                        <th class="text-center"
                        >
                            mg/kg
                        </th>
                        <th class="text-center"
                        >
                            Producto
                        </th>
                        <th class="th-check"></th>
                        <th class="text-center"
                        >
                            mg/kg
                        </th>
                        <th class="text-center"
                        >
                            Producto
                        </th>
                        <th class="th-check"></th>
                        <th class="text-center text-truncate"
                        >
                            ppmV/mg/l
                        </th>
                        <th class="text-center"
                        >
                            Producto
                        </th>
                    </tr>
                    </thead>

                    <tbody>
                    <tr v-for="c in grouped_components.filter(comp => !comp.omit_in_composition)"
                        v-if="(c.name + c.cas_number).trim().toLowerCase().includes(name.trim().toLowerCase())"
                    >
                        <td>
                            <b-badge variant="secondary"
                                     size="sm"
                                     class="mr-1"
                                     style="width: 90px"
                            >
                                <span v-if="c.cas_number">
                                    {{ c.cas_number }}
                                </span>
                            </b-badge>
                            {{ c.name }}
                        </td>
                        <td class="text-center">
                            <div>
                                <div class="text-right mb-1">{{ Math.round(c.final_percentage * 10000) / 10000 }}%</div>
                            </div>
                        </td>
                        <td>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="py-1 px-2"
                            >
                                <div slot="content">
                                    Marque esta casilla si sabe que este componente NO <br/>
                                    presenta toxicidad aguda por esta vía de exposición
                                </div>
                                <b-form-checkbox v-model="c.toxicity.add_dl_50_oral"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(c)"
                                                 :disabled="only_view"
                                                 class="ml-2"
                                />
                            </el-tooltip>
                        </td>
                        <td class="text-center">
                            {{
                                !!c.toxicity.dl_50_oral ? c.toxicity.dl_50_oral : 0
                            }}
                        </td>
                        <td class="text-center">
                            <div v-if="!c.toxicity || !c.toxicity.dl_50_oral">
                                0
                            </div>
                            <div v-else>
                                {{
                                    Math.round(((c.final_percentage / c.toxicity.dl_50_oral) + Number.EPSILON) * 10000) / 10000
                                }}
                            </div>
                        </td>
                        <td>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="py-1 px-2"
                            >
                                <div slot="content">
                                    Marque esta casilla si sabe que este componente NO <br/>
                                    presenta toxicidad aguda por esta vía de exposición
                                </div>
                                <b-form-checkbox v-model="c.toxicity.add_dl_50_cutaneous"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(c)"
                                                 :disabled="only_view"
                                                 class="ml-2"
                                />
                            </el-tooltip>
                        </td>
                        <td class="text-center">
                            {{
                                !!c.toxicity.dl_50_cutaneous ? c.toxicity.dl_50_cutaneous : 0
                            }}
                        </td>
                        <td class="text-center">
                            <div v-if="!c.toxicity || !c.toxicity.dl_50_cutaneous">
                                0
                            </div>
                            <div v-else>
                                {{
                                    Math.round(((c.final_percentage / c.toxicity.dl_50_cutaneous) + Number.EPSILON) * 10000) / 10000
                                }}
                            </div>
                        </td>
                        <td>
                            <el-tooltip effect="dark"
                                        placement="top"
                                        popper-class="py-1 px-2"
                            >
                                <div slot="content">
                                    Marque esta casilla si sabe que este componente NO <br/>
                                    presenta toxicidad aguda por esta vía de exposición
                                </div>
                                <b-form-checkbox v-model="c.toxicity.add_cl_50_inhalation"
                                                 :unchecked-value="0"
                                                 :value="1"
                                                 @change="_updateComponentProduct(c)"
                                                 :disabled="only_view"
                                                 class="ml-2"
                                />
                            </el-tooltip>
                        </td>
                        <td class="text-center">
                            {{
                                !!c.toxicity.cl_50_inhalation ? c.toxicity.cl_50_inhalation + (c.toxicity.measure_unit ? ' ' + c.toxicity.measure_unit.lista : '') : 0
                            }}
                        </td>
                        <td class="text-center">
                            <div v-if="!c.toxicity || !c.toxicity.cl_50_inhalation">
                                0
                            </div>
                            <div v-else>
                                {{
                                    Math.round(((c.final_percentage / c.toxicity.cl_50_inhalation) + Number.EPSILON) * 10000) / 10000
                                }}
                            </div>
                        </td>
                        <td v-if="!only_view">
                            <el-tooltip effect="dark"
                                        placement="top"
                                        content="Editar"
                                        popper-class="py-1 px-2"
                            >
                                <b-button variant="outline-primary"
                                          class="float-right mr-1"
                                          size="sm"
                                          @click="openModal(c)"
                                >
                                    <i class="fa fa-edit"/>
                                </b-button>
                            </el-tooltip>
                        </td>

                    </tr>
                    </tbody>
                </table>
            </b-col>
        </b-row>

        <modal @update="$emit('getClassifications')"/>
    </div>
</template>

<script>

import modal from './modal';
import {mapActions, mapMutations, mapState} from 'vuex';
import Classification from '../../../components/classification.vue';
import popover_info from '../../../components/popover_info.vue';

export default {
    name: 'index',
    components: {
        Classification,
        popover_info,
        modal
    },
    props: {
        name: {
            required: true,
            default: ''
        }
    },
    computed: {
        ...mapState('calculator', [
            'product',
            'only_view',
            'totals',
            'grouped_components',
        ])
    },
    methods: {
        ...mapActions('calculator', [
            'getGroupedComponents',
            'getClassification',
            'downloadClassificationAcuteToxicity',
            'updateComponentProduct',
            'updateToxicitiesComponents'
        ]),
        ...mapMutations('calculator', [
            'setModalToxicityShow',
            'setComponent'
        ]),
        openModal(component) {
            this.setComponent(JSON.parse(JSON.stringify(component)));
            this.setModalToxicityShow(true);
        },
        async _updateComponentProduct(component) {
            await this.updateToxicitiesComponents({components: [component]});
            this.$emit('getClassifications');
        }
    }
};
</script>

<style lang="scss">

.acute-toxicity {
    .table {
        border-collapse: separate;
        border-spacing: 0;
    }

    .table thead tr:first-child th:first-child {
        border-top-left-radius: 0.3rem;
    }

    .table thead tr:first-child th:last-child {
        border-top-right-radius: 0.3rem;
    }

    .table td,
    .table th {
        padding-top: 0.4rem;
        padding-bottom: 0.4rem;
    }
}

</style>
